var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LOANPURPOSE } from '../../../config/routes';
import { Container, InputSearch, PageHeading, Section } from '../../shared';
import { services } from '../../../shared/api/services';
import { CaseDashboard } from '../../sections/index';
import { useAppSelector } from '../../app/hooks';
export var CasesPage = function () {
    var _a;
    var _b = useState([]), caseDetails = _b[0], setCaseDetails = _b[1];
    var _c = useState('ApplicationId'), sortColumn = _c[0], setSortColumn = _c[1];
    var _d = useState('Desc'), sortOrder = _d[0], setSortOrder = _d[1];
    var _e = useState(' '), keyPressed = _e[0], setKeyPressed = _e[1];
    var pageSize = 10;
    var fetchCaseDetails = function (searchTerm) { return __awaiter(void 0, void 0, void 0, function () {
        var caseDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCaseSummary(searchTerm, 1, pageSize, sortColumn, sortOrder)];
                case 1:
                    caseDetails = (_a.sent()).data;
                    setCaseDetails(caseDetails);
                    return [2 /*return*/, caseDetails !== null && caseDetails !== void 0 ? caseDetails : []];
            }
        });
    }); };
    var fetchSortedData = function (column, order) { return __awaiter(void 0, void 0, void 0, function () {
        var caseDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSortOrder(order);
                    setSortColumn(column.id);
                    return [4 /*yield*/, services.getCaseSummary(' ', 1, pageSize, column.id, order)];
                case 1:
                    caseDetails = (_a.sent()).data;
                    setCaseDetails(caseDetails);
                    return [2 /*return*/, caseDetails !== null && caseDetails !== void 0 ? caseDetails : []];
            }
        });
    }); };
    var handleKey = function (e) {
        setKeyPressed(e.currentTarget.value);
    };
    var fetchPageData = function (pageNumber, pageSize) { return __awaiter(void 0, void 0, void 0, function () {
        var caseDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCaseSummary(' ', pageNumber, pageSize, sortColumn, sortOrder)];
                case 1:
                    caseDetails = (_a.sent()).data;
                    setCaseDetails(caseDetails);
                    return [2 /*return*/, caseDetails !== null && caseDetails !== void 0 ? caseDetails : []];
            }
        });
    }); };
    useEffect(function () {
        if (admindataforredirect.isAdmin) {
            window.open("".concat(window.location.origin, "/cases/application/").concat(admindataforredirect.caseId), '_self');
        }
        else {
            fetchCaseDetails(keyPressed);
        }
    }, [keyPressed]);
    var admindataforredirect = ({
        caseId: useAppSelector(function (state) { return state.adminData.adminData.caseId; }),
        isAdmin: useAppSelector(function (state) { return state.adminData.adminData.isAdmin; }),
        formId: useAppSelector(function (state) { return state.adminData.adminData.formId; }),
        loanPurposeId: useAppSelector(function (state) { return state.adminData.adminData.loanPurposeId; }),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { headingLevel: 2, title: "Cases", icon: "cases", mb: 6 }),
        React.createElement(Container, { fullWidth: true },
            React.createElement(Section, { title: "Your cases", mb: 6, headerChildren: React.createElement("div", { className: "c-search-add" },
                    React.createElement(InputSearch, { id: "search-clients", onKeyUp: handleKey }),
                    React.createElement("div", null,
                        React.createElement(Link, { to: LOANPURPOSE.path, className: "c-btn c-btn--primary" }, "Start New Case"))) },
                React.createElement(CaseDashboard, { pageSize: pageSize, caseDetails: caseDetails, pageFunction: fetchPageData, sortFunction: fetchSortedData, noOfCases: (_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.length) !== null && _a !== void 0 ? _a : 0 })))));
};
